<template>
  <InterfaceCard
      icon="mdi-account"
      title="Мой профиль"
  >
    <template slot="tabs">
      <v-tabs
          v-model="currentTab"
          :show-arrows="$vuetify.breakpoint.mobile"
      >
        <v-tabs-slider color="pink"></v-tabs-slider>

        <v-tab
            icons-and-text
            v-for="tab in tabs"
            :key="tab.id"
        >
          <v-icon left>{{tab.icon}}</v-icon>
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    </template>

    <UserProfileCommon v-if="currentTab === tabs[0].id"/>
    <UserProfileBalances v-else/>
  </InterfaceCard>
</template>

<script>
import InterfaceCard from '@/components/InterfaceCard'
import UserProfileBalances from '@/components/UserProfileBalances'
import UserProfileCommon from '@/components/UserProfileCommon'

const tabs = [{
  id: 0,
  title: 'Общее'
},{
  id: 1,
  title: 'Балансы'
}]

export default {
  name: 'UserProfile',
  components: {UserProfileCommon, UserProfileBalances, InterfaceCard},
  data () {
    return {
      currentTab: tabs[1].id,
      tabs: tabs
    }
  }
}
</script>

<style scoped>

</style>